import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator.js";

import { useLocation , Link} from "react-router-dom"; // Importa useLocation

import PageLayout from "../../layouts/PageLayout.js";


import {commitPagosGetnet}  from "../../api/giras.ts";
import { Row, Col } from "react-bootstrap";
import { AnchorComponent } from "../../components/elements/index.js";

export default function MiPagoGetnetPage() {

    const { t, n } = useContext(TranslatorContext)
    const location = useLocation();
    const [pagos, setPagos] = useState([]);
    const [ordenCompra, setOrdenCompra] = useState(null);
    
   

    useEffect(() => {
       /* 
         const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
        let token = params.get('buyOrder'); // Obtén el valor del parámetro 'gira'
        let orden = params.get('buyOrder'); // Obtén el valor del parámetro 'gira'
     

       if(orden !== null){
            setOrdenCompra(orden);
        }
        const fetchTabla = async () => {
            const res = await commitPagosGetnet(token);
            console.log(res);
            setPagos(res);
        }

        if(orden !== null){
            fetchTabla();
          }
            */
        
               
     }, []);

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                                    <div className="mc-card">
                                        <div className='mc-breadcrumb'>
                                            <h3 className="mc-breadcrumb-title">Gira de Estudio</h3>
                                            <ul className="mc-breadcrumb-list">
                                            <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                                
                                                <li className="mc-breadcrumb-item">Pagos</li>
                                            </ul>
                                        </div>
                                    </div>
                </Col>
                <Col xl={12}  style={{ height: "650px" }}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                        
                 <div className="mc-card">
                        <div className="mc-card-header">
                        
                    <div className="error-message mejorada">
                        <i className="material-icons" style={{ color: "#e53935", verticalAlign: "middle", marginRight: 8,  fontSize: "3.2rem" }}>error_outline</i>
                             <h2>Orden de Compra por Verificar</h2>
                            
                             <ul>
                                 <li>Estimado Usuario, vamos a validar el pago de sus cuotas, esto puede tardar unos minutos, recibira un email con el estado de la transacción.</li>
                                 
                             </ul>
                             </div>
                       </div>
                       <p>
                  
                    <AnchorComponent to={{ pathname: "/home" }} title="View" className="btn btn-primary">Volver </AnchorComponent>
                </p>
                       </div>  
            
                        </div>
                    </div>
                </Col>
            </Row>
            
        </PageLayout>
    );
}
